import { demystConsoleApi } from "./api";

export const publicApi = {
  async sendRegistrant(webinarId, registrant) {
    return await demystConsoleApi.post(`/public/webinars/${webinarId}/registrants`, {
      registrant,
    });
  },
};
